import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=32ee9fbc&scoped=true&"
import script from "./PPagination.vue?vue&type=script&lang=js&"
export * from "./PPagination.vue?vue&type=script&lang=js&"
import style0 from "./PPagination.vue?vue&type=style&index=0&id=32ee9fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee9fbc",
  null
  
)

export default component.exports